import React, { useState } from 'react';
import { Link } from 'tdesign-react';
import JSONModal from '@/components/JSONModal';

export default function IndividuallyModal({ detail }) {
  const [visible, setVisible] = useState(false);
  const message = detail.individuallyDeletedMessages;
  return (
    <>
      <Link theme='primary' onClick={() => setVisible(true)}>
        查看
      </Link>
      <JSONModal
        title='空洞消息'
        json={message}
        visible={visible}
        handleClose={() => setVisible(false)}
        theme={require('react-json-pretty/dist/adventure_time')}
      />
    </>
  );
}
